export default "__VITE_ASSET__e37f71ae__"